import script from "./PopoverMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopoverMenu.vue?vue&type=script&setup=true&lang=ts"

import "./PopoverMenu.vue?vue&type=style&index=0&id=0601c49f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0601c49f"]])

export default __exports__